import React from 'react'
import cx from 'classnames'

import s from './Overlay.scss'


const Overlay = ({ children, className, onClick }) => (
  <div className={cx(s.overlay, className)} onClick={onClick}>
    {children}
  </div>
)


export default Overlay
